import helperService from './helper.service'
import APIError from '../models/api/api.error'
import authService from "../Services/Auth.service";
import {getApiUrl} from './platform.url.service'

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export default {
  /**
   *
   * @param url
   * @param method
   * @param body
   * @param headers
   * @param timeout (em segundos) - padrão: 2 min
   * @returns {Promise<*>}
   */
  executeAPI: async (url, method, body, headers, timeout = 120) => {

    url = getApiUrl(url);

    if (timeout === undefined) {
      timeout = 300 // 5 min padrão

      if (process.env.NODE_ENV === 'development')
        timeout = 3600 // 60 min para debug
    }

    const timeoutDuration = timeout * 1000 // convert para o steTimeout
    const retries = 2 // tentativas de reconexão
    const retriesDelay = 1000 // 1 segundo

    function executeFecth(url, method, body, headers, timeout, retries, retriesDelay) {

      // Função para criar uma promessa que rejeita após o timeout
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Request timed out'));
        }, timeoutDuration);
      });

      // Faz a requisição fetch e compete com o timeout
      return Promise.race([
        fetch(url, {
          method: method,
          headers: headers,
          body: body ? JSON.stringify(body) : undefined,
        }).then(response => {
          return helperService.getHttpErrror(response).then(responseError => {
            if (responseError) {
              return responseError;
            } else {
              return response.json();
            }
          });
        }).then(responseJson => {
          return responseJson;
        }),
        timeoutPromise,
      ]).catch(async error => {

        if (error.message === 'Request timed out') {
          console.log(`Timeout: Tempo limite excedido para esta requisição (${timeout / 1000} segundos)`);

          return {
            Message: `Timeout: Tempo limite excedido para esta requisição (${timeout / 1000} segundos)`,
            Type: 'error',
            Error: 'Timeout',
          };
        }

        if (error instanceof TypeError && error.message === "Failed to fetch") {
          // Checa se o erro é de conexão e reduz as tentativas
          if (method === 'GET' && retries > 0) {
            console.warn(`Erro de conexão. Tentando novamente... (${retries} tentativa)`);
            await delay(retriesDelay);
            return await executeFecth(url, method, body, headers, timeout, retries - 1, retriesDelay);
          }
        }

        // Se as tentativas se esgotarem ou for outro tipo de erro
        if (error instanceof TypeError && error.message === "Failed to fetch") {

          if (retries === 0) {
            try {
              // await delay(retriesDelay);
              // await authService.logUsuario(url, method, body, headers);
            } catch (e) {
              console.log('erro no envio do log', e)
            }
          }

          console.error("Erro de conexão: Não foi possível alcançar o servidor.");

          return {
            Message: `Erro de conexão: Não foi possível alcançar o servidor.`,
            Type: 'error',
            Error: 'Erro de conexão',
          };
        }

        return helperService.getHttpErrror(error).then(responseError => {
          return responseError;
        });

      });

    }

    return await executeFecth(url, method, body, headers, timeoutDuration, retries, retriesDelay)

  },
  executeUploadAPI: async (url, method, formData, headers, timeout = 120) => {

    url = getApiUrl(url)

    if (timeout === undefined) {
      timeout = 300 // 5 min padrão

      if (process.env.NODE_ENV === 'development')
        timeout = 3600 // 60 min para debug
    }

    const timeoutDuration = timeout * 1000 // convert para o steTimeout

    function executeFecth(url, method, formData, headers, timeout) {

      // Função para criar uma promessa que rejeita após o timeout
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Request timed out'));
        }, timeoutDuration);
      });

      // Faz a requisição fetch e compete com o timeout
      return Promise.race([
        fetch(url, {
          method: method,
          headers: headers,
          body: formData,
        }).then(response => {
          return helperService.getHttpErrror(response).then(responseError => {
            if (responseError) {
              return responseError;
            } else {
              return response.json();
            }
          });
        }).then(responseJson => {
          return responseJson;
        }),
        timeoutPromise,
      ]).catch(async error => {

        if (error.message === 'Request timed out') {
          console.log(`Timeout: Tempo limite excedido para esta requisição (${timeout / 1000} segundos)`);

          return {
            Message: `Timeout: Tempo limite excedido para esta requisição (${timeout / 1000} segundos)`,
            Type: 'error',
            Error: 'Timeout',
          };
        }

        console.log(error);
        return helperService.getHttpErrror(error).then(responseError => {
          return responseError;
        })
      });
    }

    return await executeFecth(url, method, formData, headers, timeoutDuration)

  },
  executeExternal: async (url, method, headers) => {
    return fetch(url, {
      method: method,
      headers: headers,
      timeut: 60,
    }).then(response => {
      return helperService.getHttpErrror(response).then(responseError => {
        if (responseError) {
          return responseError;
        } else {
          return response.json()
        }
      })
    }).then(responseJson => {
      return responseJson
    }).catch(error => {
      return helperService.getHttpErrror(error).then(responseError => {
        return responseError;
      })
    })
  },
  executeDownloadBlob: async (url, method, headers) => {
    url = getApiUrl(url)

    return fetch(url, {
      method: method,
      headers: headers,
      timeut: 120,
    })
      .then(response => response.arrayBuffer())  // Transformar em ArrayBuffer
      .then(buffer => {
        return buffer;
      })
      .catch(error => {
        console.error('Erro ao carregar o PDF:', error);
      });

  },

}
